import React, { Component } from 'react';
import { HashRouter, Route, Switch, withRouter } from 'react-router-dom';
import AppConfig from '../appConfig';
import AuthGuard from './auth/AuthGuard';
import UserIdResolver from './auth/UserIdResolver';
import '../css/common.css';
import '../css/main.css';
import '../css/react-spinner.css';
import '../css/ir-navbar.css';
import '../css/sec-navbar.css';
import '../css/sidebar.css';
import '../css/buttons.css';
import 'react-table/react-table.css';
import '../css/react-table.css';
import '../css/react-modal.css';
import '../css/pageTitleBar.css';
import '../css/table.css';
import '../css/attendance.css';
import '../css/leave.css';
import '../css/admin.css';
import '../css/fonts.css';

import DashboardPage from '../pages/dashboard/index';
import ProjectPage from '../pages/projects/index';
import EmployeePage from '../pages/employees/index';
import AdminPage from '../pages/admin/index';
import ProfilePage from '../pages/profile/index';
import Navbar from './navbar/index';
import Sidebar from './navbar/sidebar';

const NavbarWithRouter = withRouter(props => <Navbar {...props} />);
const SidebarWithRouter = withRouter(props => <Sidebar {...props} />);

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sidebarMenu: false,
            toggleSidebarMenu: false
        }
        this.showSidebarMenu = this.showSidebarMenu.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
    }

    showSidebarMenu(value) {
        this.setState({ sidebarMenu: value })
    }

    toggleSidebar() {
        this.setState({ toggleSidebarMenu: !this.state.toggleSidebarMenu })
    }

    render() {
        const { sidebarMenu, toggleSidebarMenu } = this.state;
        const mainContent = (
            <>
                <div >
                    <NavbarWithRouter {...this.props} showSidebarMenu={this.showSidebarMenu} sidebarMenu={sidebarMenu} toggleSidebar={this.toggleSidebar} />
                </div>
                <div className="wrapper">
                    {sidebarMenu &&
                        <div className="sidebar" >
                            <SidebarWithRouter sidebarMenu={sidebarMenu} className={toggleSidebarMenu ? "active" : ""} />
                        </div>
                    }
                    <Switch>
                        <Route path={AppConfig.baseUrl + 'Projects'} component={ProjectPage} />
                        <Route path={AppConfig.baseUrl + 'Employees'} component={EmployeePage} />
                        <Route path={AppConfig.baseUrl + 'Profile'} component={ProfilePage} />
                        <Route path={AppConfig.baseUrl + 'Admin'} component={AdminPage} />
                        <Route path={AppConfig.baseUrl + 'Home'} component={DashboardPage} />
                        <Route exact path={AppConfig.baseUrl} component={DashboardPage} />
                    </Switch>
                </div>
            </>
        );

        const content = AppConfig.auth0.useAuth0
            ? <UserIdResolver>{mainContent}</UserIdResolver>
            : mainContent;

        return (
            <HashRouter>
                <AuthGuard>
                    <div>
                        {content}
                    </div>
                </AuthGuard>
            </HashRouter>
        );
    }
}

export default App;


